export default {
    layout: {
        loading: '取引進行中',
        trading: '取引進行中'
    },
    footer: {
       
    },
    menu: {
        home: 'ホーム',
        staking: 'マトリックス',
        port: 'PORT',
        internet: 'ネットワーク',
        me: 'マイページ',
    },
    header: {
      
        selectLang: '言語を選択',
        close: '閉じる',
        trading: '取引',
        dashboard: 'ダッシュボード',
        subscribeMatrix: 'サブスクリプションプラン',
        portTaskCenter: 'PORTタスクセンター',
        network: 'ネットワーク',
        apiBinding: 'API連携',
        gridTree: 'グリッドツリー',
        account: 'アカウント',
        documents: 'ドキュメント＆ホワイトペーパー',
        personalCenter: 'プロフィール',
        language: '言語'
    },
    home: {
        recently1:'コミュニティ',
        staticrewares: 'スタティック',
        recentlyName: '台帳',
        recentlyInfo: '収益明細',
        dataUpdate: 'データ更新',
        realtime: 'リアルタイム·BSC',
        totalRevenue: '総収益 (USDT)',
        today: '本日',
        totalTradingVolume: '総取引額',
        todayEarn: '本日獲得',
        share: '友達にシェア',
        shareDesc: '収益を共有 · 招待で報酬獲得',
        directReferrals: '直接紹介人数',
        teamMembers: 'チームメンバー',
        thisWeek: '今週',
        copy: 'Copy',
        recently: '最近の収益',
        netIncome: '純収益',
        dailyAverage: '日次平均',
        quantitativeIncome: 'クオンツ',
        recommend: '紹介',
        port: 'PORT',
        bonus: 'ボーナス',
        all: '全部',
        todayTitle: '本日',
        loadingMore: 'さらに読み込む',
    
        recommendBonus: '紹介報酬',
        portTaskPassed: 'PORTタスク完了',
        myProfit: '私の損益',
        earningOnBitDeep: 'BitDeepで収益を獲得中',
        totalRevenueUsdt: '総収益 · USDT',
        consecutiveDays: '連続日数',
        scanToJoin: 'スキャンして参加',
        uid: 'UID',
        referralBonus: 'シェア報酬',
        shareTo: '共有先',
        eachReferral: 'シェア報酬',
        screenshotAndShare: 'スクリーンショットしてシェア',
        saveShareEarn: '保存 · 転送 · 報酬獲得',
        period: 'サイクル',
        netProfit: '净收益',
        quantReward: 'クオンツ収益',
        dailyBonus: 'PORT デイリー報酬',
        close: '閉じる',
        permission: '権限',
        onlyEnable: '以下のみ有効化',
        enterBitgetUid: 'Bitget UIDを入力',
        slogan: 'パスフレーズ',
        document: 'ドキュメント',
       
        days: '日',
        taskText: 'タスク',
       
      
        minutes: '分',
    
        decentralizedPortTech: '分散型PoRTの技術アーキテクチャ、BGBトークノミクス、デュアルゾーンインセンティブマトリックス。',
        auditReport: '監査レポート',
        faqSupport: 'FAQ・サポート',
        telegram: 'Telegram',
        piece: '口',
        faq: 'FAQ',
        faq1: 'Bitget APIはどのように連携しますか？',
        faq1Desc: 'Bitget取引所 → 設定 → API管理 へ進み、API KeyとSecretを取得してください。権限は現物取引のみを有効にし、出金権限は絶対に有効にしないでください。キーをBitDeep DAppに貼り付け、1 USDTのテスト取引を完了すると連携が有効になります。',
        faq2: 'PoRT（リアル取引証明）とは何ですか？',
        faq2Desc: 'PoRTは「取引＝マイニング」の中核メカニズムです。システムは毎日、Bitget APIを通じて指定銘柄（例:BGB）の速買即売を自動実行します。取引量がステーク額×50%を超えると、システムが検証してその日の収益を発動します。',
        faq3: '毎日手動で監視する必要がありますか？',
        faq3Desc: '不要です。API連携後、システムが24時間のウィンドウ内で取引タスクを自動完了します。手動操作は不要で、PoRTメニューから進捗を確認できます。',
        faq4: 'ALPHAとSIGMAの違いは何ですか？',
        faq4Desc: 'ALPHA（初級）:500 USDTステーク、日次収益0.3〜1.3%、1セットのみ購入可能。SIGMA（プロ）:1,000 USDTステーク、日次収益0.6〜1.6%、最大5セットまで購入可能。',
        faq5: '私の資金は安全ですか？プラットフォームが私のお金を動かせますか？',
        faq5Desc: '資金は100%、お客様ご自身のBitgetアカウントに残ります。APIは現物の読み取りと取引のみを許可しており、システムは元本を出金または送金することはできません。',
        faq6: '日次収益はいつ精算されますか？',
        faq6Desc: 'PoRT検証が成功した後、翌日に精算されます。システムはUSDT収益と10x Deepポイントの2つの報酬を自動的に解放します。',
        faq7: 'スカウト報酬（直接紹介報酬）はどのように計算されますか？',
        faq7Desc: '直接紹介した有効アカウントごとに、毎日固定報酬を獲得できます:ALPHA（500 USDT）アカウントの紹介で1 USDT/日、SIGMA（1,000 USDT）アカウントの紹介で2 USDT/日、当該アカウントのサイクル終了まで支払われます。',
        faq8: 'レベル（D1〜D7）はどのようにアップグレードしますか？',
        faq8Desc: 'マイナーゾーン（弱い側）の総業績で昇格します。例:D1は2,000 USDT、D3は15,000 USDT、最高のD7は300万 USDTの業績が必要です。レベルが高いほど級差報酬が豊かになります（D7は最大7 USDT/人/日）。',
        faq9: '1サイクルは何日ですか？満期後はどうなりますか？',
        faq9Desc: '1サイクルは28日です。サイクル終了後、ステーキングを継続するか選択できます。報酬は実際の毎日のPoRT検証結果に応じて変動して支払われます。',
        faq10: '出金に手数料はかかりますか？',
        faq10Desc:'出金手数料は0です。プラットフォームは出金手数料をプール底池に還元してLP流動性を厚くし、好循環を生み出します。',
        bigArea: '大ゾーン',
        smallArea: '小ゾーン',

        enterWithdrawAmount: '出金額を入力',
        all: '全て',
        available: '利用可能',

        totalAmount: '総額',
        confirmWithdraw: '出金を確認',
        withdrawRecord: '出金履歴',

        withdrawn: '出金済み',
        quickStartGuide:'クイックスタート',
        whitepaperGuide:'ホワイトペーパー & ガイド',
        whitepaper:'ホワイトペーパー ',
        downloadPdf:'ダウンロード'
    },
    staking: {
        subscribeMatrix: '',
        selectPackage: 'サブスクリプションプラン',
        stakingDesc: '',
        alpha: 'ALPHA',
        beginner: 'スターター',
        sigma: 'SIGMA',
        professional: 'プロ',
        popular: '一番人気',
        dailyReturn: '日次利回り',
        teamDepth: 'チーム深度',
        limitPurchase: '購入上限',
        layer: '階層',
        copy: '口',
        autoRenew: '満期時に自動更新',
        autoReinvest: '元本を自動再投資',
        subscribeAlpha: 'Alphaに申込',
        subscribeSigma: 'Sigmaに申込',
        stakedAmount: 'ステーク額',
        stakedAmount2: '周期',
        stakedAmount3: '累計収益',
        stakingTime: 'ステーク日時',
        maturityTime: '満期日',
        redeem: '償還',
        renew: '更新',
        autoRenewActive: '自動更新オン',
        autoRenewInactive: '自動更新オフ',
        smartContract: 'スマートコントラクト管理。資金は28日サイクル中ロックされ、満期で解除されます。',
       
    },
    me: {
        account: 'アカウント',
        my: 'マイページ',
        staked: 'ステーク済み',
        points: 'ポイント',
        consecutive: '连续天数',
        withdraw: '出金',
        language: '言語',
        simplifiedChinese: '簡体字中国語',
        disconnectWallet: 'ウォレットを切断',
        level: 'レベル',
        joinDate: '参加日',
        bdId: 'BD-ID'
    },
    bindapi: {
        apiBinding: '連携 API',
        bindDesc: 'クオンツ取引を許可するため、取引所APIキーを連携してください',
        apiKey: 'API Key',
        apiSecret: 'API Secret',
        exchange: '取引所',
     
        futures: '先物',
        spot: '現物',
        readOnly: '読み取り専用',
        bind: '連携',

        riskNote: 'APIキーは取引データの同期のみに使用され、機密情報は保存されません。',
        apiConnection: 'API接続',
        bindExchangeApi: '取引所APIを連携',
        bitDeepRead: 'BitDeepはCEXアカウントの注文フローを読み取り、リアル取引証明(PoRT)を検証します。',
        noWithdraw: '出金には一切触れません。',
        securityTip: 'セキュリティ通知 · 必ずお読みください',
        close: '閉じる',
        withdraw: '出金',
        permission: '権限',
        onlyEnable: '以下のみ有効化',
        spotTrading: '現物引へ',
        read: '読み取り',
        recommendedPartner: 'おすすめパートナー',
        zeroFee: '0% 手数料',
        activated: '有効',
        classicAccount: 'クラシックアカウント',
        unifiedAccount: '統合アカウント',
        bindBitgetApi: 'Bitget APIを連携',
        upcoming: '近日公開',
        underAudit: '統合監査中',
        expected: '予定'
    },
    port: {
        portTaskCenter: 'PORTタスクセンター',
        dailyTask: 'デイリータスク',
        verify: '検証',
        completed: '完了',
        incomplete: '未完了',
        verifyStandard: '検証基準',
        tradingVolume: '取引額',
        today: '締切',
        deadline: '締切',
        reward: '報酬',
        startVerify: '検証を開始',
        verifying: '検証中',
        verified: '検証済み',
        insufficient: '基準未達',
        viewDetails: '詳細を見る',
        taskList: 'タスクリスト',
        allTasks: '全タスク',
        completedTasks: '完了',
        pendingTasks: '未完了',
        proofOfRealTrading: 'リアル取引証明',
        todayTask: '本日のタスク',
        todayStaticIncome: '本日のスタティック収益',
        points: '积分',
        todayWindowClosesAt: '本日の受付終了まで',
        checkTaskStatus: 'タスク状態を確認',
        teamProgress: 'チーム進捗 · 本日',
        realtimePortCompletion: 'PORTリアルタイム完了状況',
        completedText: '完了',
        pendingText: '未完了',
        realtimeApiValidationFlow: 'リアルタイム · API · 検証ストリーム',
        rewardRemark1:'Global Dividend',
        rewardRemark2:'Level-Differential Bonus',
        rewardRemark3:'Scout Bonus',
        rewardRemark4:'Task Reward',
        rewardRemark5:'PoRT Task Success',
    },
    internet: {
        network: 'ネットワーク',
        treeBrowser: 'ツリーエクスプローラ',
        searchAddress: '0x…アドレスまたはBD-IDを検索',
        totalTradingVolume: '总交易额',
        members: '名',
        networkStructure: 'ネットワーク構造',
        allLevels: '全レベル',
        addRemark: 'メモを追加',
        enterRemark: 'メモを入力してください',
        cancel: 'キャンセル',
        confirm: '確認',
    },
    whitePaper: {
    },
    withdraw: {
        withdraw: '出金額',
        usdtAsset: 'USDT資産',
        withdrawAmount: '出金額',
        availableBalance: '利用可能残高',
        fee: '手数料',
        actualArrival: '実際の受取額',
        submit: '送信',
        withdrawSuccess: '出金完了',
        withdrawFailed: '出金失敗',
        processing: '処理中',
        completed: '完了',
        withdrawHistory: '出金履歴'
    },
    popup: {
        taskUnfinished: 'タスク未完了',
        taskUnfinishedDesc: '本日のPoRT検証基準に達していません。',
        todayTradingVolume: '今日交易额',
        remaining: 'あと',
        toComplete: 'で本日のタスクを完了',
        tradingVolumeThreshold: '',
        deadline: 'タスク締切まで',
        tryAgain: '後で再試行',
        goTrade: '取引へ',
        taskCompleted: 'タスク検証成功',
        taskCompletedDesc: '本日のPoRT取引証明がオンチェーンに記録されました。',
        rewardIssued: '報酬発行',
        complete: '完了',
        shareTitle: '招待をシェア',
        shareDesc: '友達を招待して登録すると、双方が報酬を獲得できます。',
        referralLink: '招待リンク',
        qrCode: 'QRコード',
        copyLink: 'リンクをコピー',

    }
};
